export const generateRepeatedMask = (
  pattern: (string | RegExp)[],
  repetitions: number
) => {
  const result = [];
  for (let i = 0; i < repetitions; i += 1) {
    result.push(...pattern);
  }
  return result;
};

export const anyCharacterMask = generateRepeatedMask(
  [/.*/, /.*/, /.*/, /.*/, /.*/],
  100
);
export const zipCodeMask = [/\d/, /\d/, /\d/, /\d/, /\d/];
export const creditCardMask = generateRepeatedMask(
  [/\d/, /\d/, /\d/, /\d/, ' '],
  6
);
export const securityCodeMask = [/\d/, /\d/, /\d/, /\d/];

export const dateMask = [
  /\d/,
  /\d/,
  '/',
  /\d/,
  /\d/,
  '/',
  /\d/,
  /\d/,
  /\d/,
  /\d/
];

export const currencyMaskNumbers = ['$', /\d/, /\d/, /\d/, /\d/];

export const currencyMaskFormatted = ['$', /\d/, ',', /\d/, /\d/, /\d/];
